var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 2.977c-.785 0-1.57.304-2.18.914L3.89 15.75l-.046.234-.82 4.125-.235 1.102 1.102-.234 4.125-.82.234-.048L20.11 8.25a3.056 3.056 0 0 0 0-4.36 3.073 3.073 0 0 0-2.18-.913Zm0 1.43c.378 0 .759.172 1.125.538.73.73.73 1.52 0 2.25l-.54.516-2.226-2.227.516-.539c.366-.366.747-.539 1.125-.539Zm-2.696 2.132 2.227 2.227-9.07 9.07a5.11 5.11 0 0 0-2.227-2.227l9.07-9.07ZM5.204 16.83a3.55 3.55 0 0 1 1.968 1.968l-2.461.492.492-2.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettings);
export default __webpack_public_path__ + "static/media/general-settings.6bf6963fff8e4dcf3161d98bdde2220b.svg";
export { ForwardRef as ReactComponent };